import(/* webpackMode: "eager" */ "/codebuild/output/src1006363581/src/nextjs-grudder/src/app/global-error.tsx");
